import * as React from "react";
import { SaveButton } from "../../SaveButton";

interface ISubmitProps {
    loading: boolean;
    label?: string;
    onSubmit(e: any): void;
}

export const Submit = ({loading, onSubmit, ...props}: ISubmitProps) => {
    return (
        <SaveButton loading={loading} onSubmit={onSubmit} {...props} />
    );
};
